export default __webpack_public_path__ + "static/media/bl.46fa9119.png";